import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10 system-settings" }
const _hoisted_2 = { class: "card-body p-9" }
const _hoisted_3 = { class: "pb-10" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = { class: "pb-10 pb-lg-15 pt-10 text-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "settings-main-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-cogs" })
], -1)
const _hoisted_7 = { class: "fw-bolder text-center" }
const _hoisted_8 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_9 = { class: "fv-row mb-8" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "fv-row mb-8" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "fv-row mb-8" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "fv-row mb-8" }
const _hoisted_16 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SystemConfig = _resolveComponent("SystemConfig")!
  const _component_Sites = _resolveComponent("Sites")!
  const _component_Taxes = _resolveComponent("Taxes")!
  const _component_Discounts = _resolveComponent("Discounts")!
  const _component_ShippingMethods = _resolveComponent("ShippingMethods")!
  const _component_PaymentMethods = _resolveComponent("PaymentMethods")!
  const _component_Languages = _resolveComponent("Languages")!
  const _component_HomeController = _resolveComponent("HomeController")!
  const _component_SystemSettingsStatus = _resolveComponent("SystemSettingsStatus")!
  const _component_ShopFooter = _resolveComponent("ShopFooter")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("h1", _hoisted_7, _toDisplayString(`${_ctx.$t('message.SYSTEM')} ${_ctx.$t('message.SETTINGS')}`), 1),
            _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('message.CHANGE_SYSTEM_SETTINGS_AND_CONFIGURATIONS')), 1)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              (_ctx.$can('view_system_configuration'))
                ? (_openBlock(), _createBlock(_component_SystemConfig, { key: 0 }))
                : _createCommentVNode("", true),
              (_ctx.$can('view_sites_list'))
                ? (_openBlock(), _createBlock(_component_Sites, { key: 1 }))
                : _createCommentVNode("", true),
              (_ctx.$can('view_taxes_list'))
                ? (_openBlock(), _createBlock(_component_Taxes, { key: 2 }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              (_ctx.$can('view_discounts_list'))
                ? (_openBlock(), _createBlock(_component_Discounts, { key: 0 }))
                : _createCommentVNode("", true),
              (_ctx.$can('view_shipping_methods_list'))
                ? (_openBlock(), _createBlock(_component_ShippingMethods, { key: 1 }))
                : _createCommentVNode("", true),
              (_ctx.$can('view_payment_methods_list'))
                ? (_openBlock(), _createBlock(_component_PaymentMethods, { key: 2 }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              (_ctx.$can('view_translation_list'))
                ? (_openBlock(), _createBlock(_component_Languages, { key: 0 }))
                : _createCommentVNode("", true),
              (_ctx.$can('view_home_screen_list'))
                ? (_openBlock(), _createBlock(_component_HomeController, { key: 1 }))
                : _createCommentVNode("", true),
              (_ctx.$can('view_settings_status'))
                ? (_openBlock(), _createBlock(_component_SystemSettingsStatus, { key: 2 }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              (_ctx.$can('view_shop_footer'))
                ? (_openBlock(), _createBlock(_component_ShopFooter, { key: 0 }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}